// Этот файл генерируется автоматически, его не следует редактировать вручную
import collapse from '@/widgets/collapse.js';
import form from '@/widgets/form.js';
import imageGallery from '@/widgets/imageGallery.js';
import mapBlock from '@/widgets/mapBlock.js';
import openVacancyPopupForm from '@/widgets/openVacancyPopupForm.js';

export default {
  'collapse': async () => { return { default: collapse }; },
  'form': async () => { return { default: form }; },
  'formPopup': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/formPopup.js'),
  'imageGallery': async () => { return { default: imageGallery }; },
  'mapBlock': async () => { return { default: mapBlock }; },
  'mobileMenu': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/mobileMenu.js'),
  'mobileMenuButton': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/mobileMenuButton.js'),
  'openPopupForm': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/openPopupForm.js'),
  'openVacancyPopupForm': async () => { return { default: openVacancyPopupForm }; },
  'scrollTop': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollTop.js'),
  'scrollWatcher': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollWatcher.js'),
  'tabsSwitch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/tabsSwitch.js'),
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js'),
  'upload': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/upload.js')
};
